import queryString from "query-string";
import { useLocation } from "react-router-dom";
import RoutePage from "../RoutePage";
import { Radio, Spin } from "antd";
import { useEffect, useState } from "react";
import liracrypt from "../Liracrypt/liracrypt";
import { LoadingOutlined } from "@ant-design/icons";

const ManagerDashboard = ({
  setPageHeader
}) => {
  const [tabsData, setTabsData] = useState();
  const [selectedTab, setSelectedTab] = useState();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const searchParams = queryString.parse(search);

  const getTabs = () => {
    setLoading(true);
    liracrypt.get('/dashboardtabsmultiparam', { ...searchParams })
      .then(response => {
        if (setPageHeader) {
          setPageHeader(response.data.config?.pageTitle || 'Dashboard')
        }
        let __tabs = response.data.data;
        setTabsData(__tabs);
        setSelectedTab(__tabs?.find(x => x.isDefault === true)?.subTyp);
        setLoading(false);
      }).catch(err => {
        console.log(err);
      });
  };

  const clearRecentCache = () => {
    const cacheData = { ...localStorage };
    Object.keys(cacheData).forEach(key => {
      if (key.includes('cache_')) {
        localStorage.removeItem(key);
      }
    });
  }


  useEffect(() => {
    clearRecentCache();
  }, []);

  useEffect(() => {
    // if (setPageHeader) {
    //   setPageHeader('Dashboard');
    // }
    getTabs();
  }, [search]);

  const onChange = (e) => {
    setLoading(true);
    setSelectedTab(e.target.value);
    setTimeout(() => {
      setLoading(false);
    }, 20);
  };

  return (
    <div style={{ padding: 15 }}>
      <div>
        <Radio.Group
          className="managerTabs"
          value={"small"}
          onChange={onChange}
        >
          {
            tabsData && (
              tabsData.map((tab, index) => (
                <Radio.Button
                  key={index}
                  className={tab?.label?.toLowerCase()}
                  style={{
                    backgroundColor: "#093066",
                    color: "#b9d6ff",
                    textAlign: "center",
                    fontSize: "17px",
                    fontWeight: 600,

                    maxWidth: "250px",
                  }
                  }
                  value={tab?.subTyp}
                >
                  {tab?.label}
                </Radio.Button>
              ))
            )
          }
        </Radio.Group>
        {loading === false ? (
          <div>
            <RoutePage params={{ tab: selectedTab, ...searchParams }} route={tabsData.find(x => x.subTyp === selectedTab)?.route} />
          </div>
        ) : (
          <div className="Loading" style={{ minHeight: "100vh" }}>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} />} />
          </div>
        )}
      </div >
    </div>
  )
};

export default ManagerDashboard;